import React, { useState } from 'react';
import "./CodeBlockHeader.css"
import { copySign } from '../../../utils';
import {logError} from "../../../utils/logger";

interface CodeBlockHeaderProps {
  langName: string;
  code: string;
}

export const CodeBlockHeader: React.FC <CodeBlockHeaderProps> = ({ langName, code }) => {
  const [copyText, setCopyText] = useState("Copy");

const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopyText("Code copied!");
      setTimeout(() => {
        setCopyText("Copy");
      }, 4000);
    } catch (err) {
      logError("Failed to copy text: ", err);
      setCopyText("Failed to copy");
      setTimeout(() => {
        setCopyText("Copy");
      }, 4000);
    }
  };

  
  return (
    <div className="codeBlockHeader">
      <span>{langName}</span>
      <section onClick={handleCopy}>
        <img src={copySign} alt='CopyImg'/>
        <span>{copyText}</span>
      </section>
    </div>
  );
};

